export function createLink(params: string[]) {
  const cleanedParams = params.map((param) => cleanName(param))
  return cleanedParams.join('/')
}

export function cleanName(localite: string) {
  const cleanName = localite.replace("'", '-').replace(' ', '-')

  return cleanName
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
}
